import { Button, Modal } from "@heroui/react";

export type PreviewImage = { url: string; name: string };

/** The full-size image viewer opened from a thumbnail. */
export function ImagePreviewModal({
  image,
  onClose,
  title = "Image",
}: {
  image: PreviewImage | null;
  onClose: () => void;
  title?: string;
}) {
  return (
    <Modal.Backdrop
      isOpen={!!image}
      variant="opaque"
      onOpenChange={(open) => !open && onClose()}
    >
      <Modal.Container placement="center">
        <Modal.Dialog className="w-full max-w-md">
          <Modal.CloseTrigger />
          <Modal.Header>
            <Modal.Heading>{title}</Modal.Heading>
            <p className="text-muted text-sm">{image?.name}</p>
          </Modal.Header>
          <Modal.Body className="p-1">
            {image ? (
              <div className="bg-surface-secondary flex items-center justify-center rounded-2xl p-4">
                <img
                  alt={image.name}
                  className="max-h-[60vh] max-w-full rounded-xl object-contain"
                  src={image.url}
                />
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="ghost" onPress={onClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
}
